import { useRef } from "react";
import uploadIcon from "../assets/upload.svg";
import { uploadCgmFile } from "../data/postcgm";

export default function UploadCgm({ patient }) {
  const fileInputRef = useRef();

  const handleClick = () => {
    if (!patient?.owner_id) {
      alert("Select a patient first.");
      return;
    }
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!patient?.owner_id) {
      alert("No patient selected.");
      return;
    }

    try {
      await uploadCgmFile(patient.owner_id, file);
      alert("Upload successful 🚀");
      window.location.reload();
    } catch (err) {
      console.error("💥 Upload failed:", err);
      alert("Upload failed ❌");
    }

    e.target.value = null;
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4, width: "fit-content", margin: "0 auto" }}>
        <span style={{ fontSize: 11, color: "#64748b", fontWeight: 600, textAlign: "center", width: "100%" }}>Import CGM</span>
        <img
          src={uploadIcon}
          className="topbar-upload"
          alt="Import CGM"
          onClick={handleClick}
          title="Import CGM data (.xlsx)"
          style={{ transform: "scaleY(-1)", cursor: "pointer", display: "block", margin: "0 auto" }}
        />
      </div>
      <input
        type="file"
        accept=".xlsx,.xls"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
}